<template functional>
  <transition name="background-mask-transition">
    <div v-if="props.show" class="background-mask-container">
      <div class="background-mask" @click="listeners.click"></div>
    </div>
  </transition>
</template>
<script>
export default {
  props: ['show'],
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.background-mask {
  z-index: 11;
  top: 0;
  position: fixed;
  height: 100vh;
  width: 100%;
  background-color: var(--overlay-color);
  transition: background-color 150ms ease-in-out;
}

.background-mask-transition-enter,
.background-mask-transition-leave-to {
  .background-mask {
    background-color: var(--overlay-color);
  }
}
</style>
